<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Checkbox, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { get_gen_2_component_channel_structure, real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	
	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let loading = false;

	let checked =
		$settingsStore[get_gen_2_component_channel_structure(device)]
			?.monitor_phase_sequence;

	const setMonitorPhaseSequence = async () => {
		loading = true;
		const res = await gen2Request(device, 'EM.SetConfig', {
			id: 0,
			config: { monitor_phase_sequence: checked },
		});
		await onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Text class="mb-m" styleType="body-small"
	>{$format('monitor_phase_sequence_description', {
		default: 'Set this to indicate if CTs are placed incorrectly in a three phase system.',
	})}</Text
>

<Checkbox class="mb-s" size="m" disabled={loading} bind:checked value={true} id="checkbox-tccmcsk"
	>{$format('label_enable')}</Checkbox
>

<Button {loading} width="full" size="m" on:click={setMonitorPhaseSequence}
	>{capFirstChar($format('button_save'))}</Button
>
